// src/authConfig.ts
export const msalConfig = {
    auth: {
        clientId: "e95e70e5-c70c-491d-9a99-a8d0dcd40157",
        authority: "https://login.microsoftonline.com/1c6973ce-bbb5-417e-b97e-37f8160edb68",
        // redirectUri: "https://localhost:3000",
        redirectUri: "https://neonlens.com.br"
        //redirectUri: "https://neonlens-hmg.azurewebsites.net",
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

export const loginRequest = {
    scopes: [
        "api://1c6973ce-bbb5-417e-b97e-37f8160edb68/e95e70e5-c70c-491d-9a99-a8d0dcd40157/user_impersonation",
    ]
};

export const loginRequestMS = {
    scopes: [
        "user.read"
    ]
};